if (!customElements.get("product-info")) {
  customElements.define(
    "product-info",
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
      }

      get variantSelectors() {
        return this.querySelector("variant-picker");
      }

      get productMedia() {
        return this.querySelector(
          `[id^="MediaGallery-${this.dataset.section}"]`
        );
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get productUrl() {
        return this.dataset.url;
      }

      get productId() {
        return this.getAttribute("data-product-id");
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get inventoryStatus() {
        return this.querySelector(`#Inventory-${this.dataset.section}`);
      }

      get sku() {
        return this.querySelector(`#Sku-${this.dataset.section}`);
      }

      get availability() {
        return this.querySelector(`#Availability-${this.dataset.section}`);
      }

      get enableVariantGroupImages() {
        return this.dataset.enableVariantGroupImages === "true" || false;
      }

      get disableDefaultSelectVariant() {
        return this.dataset.disableDefaultSelectVariant === "true" || false;
      }

      get productForm() {
        return this.querySelector("product-form");
      }

      get quantityInput() {
        return this.querySelector("quantity-input input");
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector(
          "variant-picker [data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      getVariantGroupImages() {
        return (
          JSON.parse(
            this.querySelector('#VariantGroupImages[type="application/json"]')
              .textContent
          ) || {}
        );
      }

      getProductOptionByName(optionName, productData) {
        for (var i = 0; i < productData.options.length; i++) {
          var option = productData.options[i];
          if (option["name"] === optionName) {
            return option;
          }
        }
        return null;
      }

      async getProductData() {
        try {
          const response = await fetch(this.dataset.productUrl + ".js");
          if (!response.ok) {
            throw new Error(
              `Bad HTTP status of the request (${response.status}).`
            );
          }
          const data = await response.json();
          return data;
        } catch (err) {
          console.log(
            `An error occurred while processing the request. Error message: ${err.message}`
          );
        }
      }

      async init() {
        this.onVariantChangeUnsubscriber = window.FoxThemeEvents.subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        if (this.enableVariantGroupImages) {
          this.variantGroupImages = this.getVariantGroupImages();
        }

        this.addEventListener("product-media:loaded", (evt) => {
          this.updateMedia(evt.detail.currentVariant);
        });

        this.productData = await this.getProductData();
        this.Notification = window.FoxTheme.Notification;

        if (this.productData && this.disableDefaultSelectVariant) {
          this.handleDisableDefaultSelectVariant();
        }
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          __reInitTooltip(newNode);
          window?.Shopify?.PaymentButton?.init();
          console.log("init");
          window?.ProductModel?.loadShopifyXR();
        });
      }

      connectedCallback() {
        this.initializeProductSwapUtility();
        this.init();

        this.initQuantityHandlers();
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      handleDisableDefaultSelectVariant() {
        const stickyAtc = document.querySelector(".sticky-atc-bar");
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        if (stickyAtc) {
          stickyAtc.classList.add("f-hidden");
        }

        this.inventoryStatus && this.inventoryStatus.setAttribute("hidden", "");
        this.sku && this.sku.classList.add("hidden");
        this.availability && this.availability.classList.add("hidden");

        let isVariantChange = false;
        this.pickerFields = this.querySelectorAll("[data-picker-field]");

        this.pickerFields &&
          this.pickerFields.forEach((field) => {
            let optionName = field.dataset.optionName;
            let optionInfo = this.getProductOptionByName(
              optionName,
              this.productData
            );

            if (optionInfo && optionInfo.values.length > 1) {
              isVariantChange = true;
              let pickerType = field.dataset.pickerField;
              switch (pickerType) {
                case "select":
                  let selectBox = field.querySelector("select");
                  let option = document.createElement("option");
                  option.text = this.dataset.variantOptionNoneText;
                  option.setAttribute("disabled", "");
                  option.setAttribute("selected", "");

                  selectBox.add(option, 0);
                  break;
                default:
                  let checkedInputs = field.querySelectorAll("input:checked");
                  checkedInputs &&
                    checkedInputs.forEach(function (input) {
                      input.removeAttribute("checked");
                    });
                  break;
              }

              field.dataset.selectedValue = "";
              if (field.querySelector(".selected-value")) {
                field.querySelector(".selected-value").textContent = "";
              }
            }
          });

        if (isVariantChange) {
          document
            .querySelectorAll(
              `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
            )
            .forEach((productForm) => {
              const input = productForm.querySelector('input[name="id"]');
              input.value = "";
            });

          const atcButton = this.querySelector('[name="add"]');
          const buyNowButton = this.querySelector(
            ".shopify-payment-button__button"
          );

          atcButton.addEventListener(
            "click",
            this.handleDisableDefaultSelectVariantMessage.bind(this)
          );
          buyNowButton &&
            buyNowButton.addEventListener(
              "click",
              this.handleDisableDefaultSelectVariantMessage.bind(this)
            );
        }
      }

      handleDisableDefaultSelectVariantMessage(evt) {
        if (!this.currentVariant) {
          evt.preventDefault();
          this.pickerFields &&
            this.pickerFields.forEach((pickerField) => {
              if ("" === pickerField.dataset.selectedValue) {
                pickerField
                  .closest(".variant-picker__field-wrapper")
                  .classList.add("is-error");
              }
            });

          this.Notification.show({
            target: this.productForm,
            method: "appendChild",
            type: "warning",
            last: 3000,
            message: this.dataset.variantSelectionNeededText,
          });
        }
      }

      handleOptionValueChange({
        data: { event, target, selectedOptionValues },
      }) {
        if (!this.contains(event.target)) return;
        const productUrl =
          target.dataset.productUrl ||
          this.pendingRequestUrl ||
          this.dataset.productUrl;
        const shouldSwapProduct = this.dataset.productUrl !== productUrl;
        const shouldFetchFullPage =
          this.dataset.updateUrl === "true" && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(
            productUrl,
            selectedOptionValues,
            shouldFetchFullPage
          ),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          const selector = updateFullPage
            ? "product-info[id^='MainProduct']"
            : "product-info";

          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            const currentShareModal = document.getElementById(
              `PopupModal-Sharing-${this.sectionId}`
            );
            document.querySelector("head title").innerHTML =
              html.querySelector("head title").innerHTML;
            if (currentShareModal) document.body.removeChild(currentShareModal);

            HTMLUpdateUtility.viewTransition(
              document.querySelector("main"),
              html.querySelector("main"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById("shopify-section-sticky-atc-bar"),
              html.getElementById("shopify-section-sticky-atc-bar"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector("product-info"),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);
          this.toolTip = __reInitTooltip(this);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(variant);

          const updateSourceFromDestination = (id) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.sectionId}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              if (source.hasAttribute("hidden")) {
                destination.setAttribute("hidden", "");
              } else {
                destination.removeAttribute("hidden");
              }
            }
          };

          updateSourceFromDestination("Price");
          updateSourceFromDestination("Volume");
          updateSourceFromDestination("PricePerItem");
          updateSourceFromDestination("Inventory");
          updateSourceFromDestination("Sku");
          updateSourceFromDestination("Availability");
          updateSourceFromDestination("FormatVariant");

          this.updateQuantityRules(this.sectionId, this.productId, html);
          updateSourceFromDestination("QuantityRules");
          updateSourceFromDestination("QuantityRulesCart");
          updateSourceFromDestination("VolumeNote");

          const addButtonUpdated = html.getElementById(
            `ProductSubmitButton-${this.sectionId}`
          );
          this.updateButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
            window.FoxThemeStrings.soldOut
          );
          this.currentVariant = variant;

          window.FoxThemeEvents.emit(PUB_SUB_EVENTS.variantChange, {
            data: { variant, sectionId: this.sectionId, html },
          });

          document.dispatchEvent(
            new CustomEvent("variant:changed", {
              detail: {
                variant: this.currentVariant,
              },
            })
          );
        };
      }

      buildRequestUrlWithParams(
        url,
        optionValues,
        shouldFetchFullPage = false
      ) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(",")}`);
        }

        return `${url}?${params.join("&")}`;
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === "AbortError") {
              console.log("Fetch aborted by user");
            } else {
              console.error(error);
            }
          });
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector("variant-picker");
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(
            this.variantSelectors,
            variantSelects,
            this.preProcessHtmlCallbacks
          );
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${url}${variantId ? `?variant=${variantId}` : ""}`
        );
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(
          `ShareButton-${this.dataset.section}`
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${variantId}`
        );
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
          )
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? "";
            input.dispatchEvent(new Event("change", { bubbles: true }));
          });
      }

      updateButton(disable = true, text) {
        const productForm = document.getElementById(
          `product-form-${this.sectionId}`
        );
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector(
          '[name="add"] > span:not(.f-icon)'
        );

        if (!addButton) return;
        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.FoxThemeStrings.addToCart;
        }
      }
      
      // Variant metafield images handling
      getVariantMetafieldImageMap() {
        if (this.variantMetafieldImageMap) return this.variantMetafieldImageMap;
        const el =
          this.productMedia &&
          this.productMedia.querySelector("[data-variant-metafield-images]");
        if (!el) {
          this.variantMetafieldImageMap = {};
          return this.variantMetafieldImageMap;
        }
        try {
          this.variantMetafieldImageMap = JSON.parse(el.textContent) || {};
        } catch (e) {
          this.variantMetafieldImageMap = {};
        }
        return this.variantMetafieldImageMap;
      }

      getVariantMetafieldUrls(variantId) {
        const map = this.getVariantMetafieldImageMap();
        const raw = map[String(variantId)];
        if (typeof raw === "string") {
          const val = raw.trim();
          return val ? [val] : [];
        }
        if (!Array.isArray(raw)) return [];
        const out = [];
        raw.forEach((url) => {
          if (typeof url !== "string") return;
          const val = url.trim();
          if (!val) return;
          out.push(val);
        });
        return out;
      }

      hasAnyVariantMetafieldImages() {
        const map = this.getVariantMetafieldImageMap();
        return Object.keys(map).some((key) => {
          const value = map[key];
          if (typeof value === "string") return value.trim() !== "";
          if (!Array.isArray(value)) return false;
          return value.some((url) => typeof url === "string" && url.trim() !== "");
        });
      }

      cacheDefaultGalleryNodes() {
        if (this.defaultMediaNodes && this.defaultThumbNodes) return;
        if (!this.productMedia) return;

        this.defaultMediaNodes = Array.from(
          this.productMedia.querySelectorAll(".f-product__media")
        ).map((node) => node.cloneNode(true));

        this.defaultThumbNodes = Array.from(
          this.productMedia.querySelectorAll(".f-product__media-thumbnails-item")
        ).map((node) => node.cloneNode(true));
      }

      isVideoUrl(url) {
        if (typeof url !== "string") return false;
        
        if (/\.(mp4|webm|mov|m4v|ogv|m3u8|mpd)(\?|#|$)/i.test(url)) {
          return true;
        }
        
        if (/\/(video|videos|hls|dash)\//i.test(url)) {
          return true;
        }
        
        return false;
      }
      
      isHlsUrl(url) {
        if (typeof url !== "string") return false;
        return /\.m3u8(\?|#|$)/i.test(url) || /\/hls\//i.test(url);
      }
      
      getVideoMimeType(url) {
        if (this.isHlsUrl(url)) return "application/x-mpegURL";
        if (/\.mpd(\?|#|$)/i.test(url)) return "application/dash+xml";
        
        const match = url.match(/\.(mp4|webm|mov|m4v|ogv)(\?|#|$)/i);
        if (!match) return "video/mp4";
        const ext = match[1].toLowerCase();
        const map = { mp4: "video/mp4", webm: "video/webm", mov: "video/quicktime", m4v: "video/mp4", ogv: "video/ogg" };
        return map[ext] || "video/mp4";
      }

      escapeHtmlAttribute(value) {
        return String(value ?? "")
          .replace(/&/g, "&amp;")
          .replace(/"/g, "&quot;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;");
      }

      // Testo alternativo per i media generati dai metafield variante:
      // titolo prodotto + titolo variante + posizione, così da non emettere mai alt vuoto.
      buildMetafieldMediaAlt(index, variant) {
        const productTitle =
          (this.productMedia && this.productMedia.dataset.productTitle) ||
          this.productData?.title ||
          "";
        const variantTitle =
          variant && variant.title && variant.title !== "Default Title"
            ? variant.title
            : "";
        const label = [productTitle, variantTitle].filter(Boolean).join(" - ");
        if (!label) return "";
        return this.escapeHtmlAttribute(`${label} (${index + 1})`);
      }

      createMetafieldMediaNode(url, index, variant) {
        const id = `metafield-${index}`;
        const el = document.createElement("div");
        const isVideo = this.isVideoUrl(url);
      
        el.id = `f-product__media-${id}`;
        el.className = `f-product__media f-product__media--${isVideo ? "video" : "image"}${isVideo ? " f-video__wrapper" : ""} w-full`;
        el.setAttribute("data-media-type", isVideo ? "video" : "image");
        el.setAttribute("data-media-id", id);
        el.setAttribute("data-media-index", index);
        el.setAttribute("data-index", index);
        el.setAttribute("data-aspect-ratio", "1");
        el.setAttribute("data-src", url);
        el.setAttribute("data-pswp-width", "2000");
        el.setAttribute("data-pswp-height", "2000");
        el.setAttribute("tabindex", "-1");
        el.setAttribute("role", "listitem");
        el.style.cssText = "--aspect-ratio: 1;";
      
        if (isVideo) {
          const mime = this.getVideoMimeType(url);
          el.innerHTML =
            '<div class="f-product__media-video-inner" style="--aspect-ratio: 1;aspect-ratio:1;width:100%;height:100%;">' +
            `<video class="f-product__metafield-video" muted playsinline loop preload="metadata" style="width:100%;height:100%;object-fit:cover;display:block;" data-metafield-video>` +
            `<source src="${url}" type="${mime}">` +
            '</video>' +
            '</div>';
        } else {
          const alt = this.buildMetafieldMediaAlt(index, variant);
          el.innerHTML =
            '<div><responsive-image class="f-image" data-image-loading style="--aspect-ratio: 1">' +
            `<img src="${url}" srcset="${url} 2000w" sizes="(min-width: 990px) 50vw, 100vw" loading="lazy" width="1000" height="1000" alt="${alt}">` +
            "</responsive-image></div>";
        }
        return el;
      }

      createMetafieldThumbNode(url, index, variant) {
        const id = `metafield-${index}`;
        const el = document.createElement("div");
        const isVideo = this.isVideoUrl(url);

        el.id = `GalleryThumbnailItem-${this.sectionId}-${index + 1}`;
        el.className = "f-column f-product__media-thumbnails-item";
        el.setAttribute("data-media-id", id);
        el.setAttribute("data-media-type", isVideo ? "video" : "image");
        el.setAttribute("data-thumbnail-type", isVideo ? "video" : "image");
        el.setAttribute("data-thumbnail-index", index);
        el.setAttribute("data-index", index);

        if (isVideo) {
          const mime = this.getVideoMimeType(url);
          el.innerHTML =
            '<div class="f-product__media-thumbnails-item-wrap block w-full" style="position:relative;">' +
            '<span class="f-product__media-badge f-product__media-badge--video" aria-hidden="true" style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;z-index:2;pointer-events:none;">' +
            this.getPlayIconSvg() +
            '</span>' +
            `<video muted playsinline preload="auto" data-metafield-thumb-video style="width:100%;height:100%;object-fit:cover;aspect-ratio:1;display:block;">` +
            `<source src="${url}#t=0.1" type="${mime}">` +
            '</video>' +
            '</div>';
        } else {
          const alt = this.buildMetafieldMediaAlt(index, variant);
          el.innerHTML =
            '<div class="f-product__media-thumbnails-item-wrap block w-full">' +
            '<responsive-image class="f-image" data-image-loading style="--aspect-ratio: 1">' +
            `<img src="${url}" srcset="${url} 208w" sizes="120px" alt="${alt}" height="100" width="100" loading="lazy">` +
            "</responsive-image></div>";
        }
        return el;
      }

      getPlayIconSvg() {
        return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" style="background:rgba(255,255,255,0.25);border-radius:50%;padding:4px;"><path d="M8 5v14l11-7z"/></svg>';
      }

      applyMediaUiState(mainMedia, thumbMedia, slideCount) {
        const viewer = this.productMedia.querySelector('[id^="GalleryViewer"]');
        const thumbWrapper = this.productMedia.querySelector(
          ".f-product__media-thumbnails-wrapper"
        );
        const pageCounter = mainMedia.querySelector(".flickity-page-counter");

        if (viewer) {
          viewer.classList.toggle("f-product__media-only--image", slideCount < 2);
          viewer.classList.toggle("f-product__media-mobile-full", slideCount < 3);
        }

        if (mainMedia) {
          mainMedia.classList.toggle("flickity-disabled", slideCount < 2);
          mainMedia.classList.toggle("flickity-controls-group-mb__inner", slideCount < 3);
          if (slideCount > 1) {
            mainMedia.style.setProperty(
              "--pagination-width",
              slideCount > 9 ? "4rem" : "2.5rem"
            );
          }
        }

        if (this.productMedia) {
          this.productMedia.dataset.onlyImage = String(slideCount < 2);
          this.productMedia.onlyImage = slideCount < 2;
        }

        if (pageCounter) {
          const current = pageCounter.querySelector(".flickity-counter--current");
          const total = pageCounter.querySelector(".flickity-counter--total");
          if (current) current.textContent = "1";
          if (total) total.textContent = slideCount;
          pageCounter.classList.toggle("hidden", slideCount <= 1);
          pageCounter.classList.toggle("inline-flex", slideCount > 1);
        }

        if (thumbWrapper) {
          thumbWrapper.style.display = slideCount > 1 ? "" : "none";
        }

        if (thumbMedia) {
          const thumbCols = parseInt(thumbMedia.dataset.sliderColumns || "5", 10);
          thumbMedia.classList.remove("disable-transition", "md:disable-transition");
          if (slideCount <= thumbCols) thumbMedia.classList.add("disable-transition");
          if (slideCount < thumbCols + 1) thumbMedia.classList.add("md:disable-transition");
        }
      }

      replaceMediaNodes(mediaNodes, thumbNodes) {
        const mainMedia = this.productMedia.querySelector(".f-product__media-list");
        const thumbMedia = this.productMedia.querySelector(
          ".f-product__media-thumbnails"
        );
        if (!mainMedia) return;

        mainMedia.numberSlides = mediaNodes.length;
        if (thumbMedia) thumbMedia.numberSlides = thumbNodes.length;

        const isCarousel = this.productMedia.querySelector(".flickity-slider")
          ? true
          : false;

        if (isCarousel) {
          const mainFlickity = window.FoxTheme.Flickity.data(mainMedia);
          if (mainFlickity) {
            mainMedia.querySelectorAll(".f-product__media").forEach((slide) => {
              mainFlickity.remove(slide);
            });
            mediaNodes.forEach((slide, index) => {
              const zoomButton = slide.querySelector(".js-photoswipe--zoom");
              if (zoomButton) zoomButton.setAttribute("data-media-index", index);
              slide.setAttribute("data-media-index", index);
              slide.setAttribute("data-index", index);
              mainFlickity.append(slide);
            });
            mainFlickity.select(0, false, false);
          }

          if (thumbMedia) {
            const thumbFlickity = window.FoxTheme.Flickity.data(thumbMedia);
            if (thumbFlickity) {
              const thumbCols = parseInt(
                thumbMedia.dataset.sliderColumns || "5",
                10
              );
              thumbMedia
                .querySelectorAll(".f-product__media-thumbnails-item")
                .forEach((slide) => {
                  thumbFlickity.remove(slide);
                });

              thumbNodes.forEach((slide, index) => {
                slide.setAttribute("data-thumbnail-index", index);
                slide.setAttribute("data-index", index);
                thumbFlickity.append(slide);
              });

              thumbFlickity.option({ wrapAround: thumbNodes.length > thumbCols });
              thumbFlickity.reloadCells();
              thumbFlickity.reposition();
            }
          }
        } else {
          mainMedia.innerHTML = "";
          mediaNodes.forEach((slide, index) => {
            const zoomButton = slide.querySelector(".js-photoswipe--zoom");
            if (zoomButton) zoomButton.setAttribute("data-media-index", index);
            slide.setAttribute("data-media-index", index);
            slide.setAttribute("data-index", index);
            mainMedia.append(slide);
          });

          if (thumbMedia) {
            thumbMedia.innerHTML = "";
            thumbNodes.forEach((slide, index) => {
              slide.setAttribute("data-thumbnail-index", index);
              slide.setAttribute("data-index", index);
              thumbMedia.append(slide);
            });
          }

          if (
            mediaNodes.length > 1 &&
            mainMedia.dataset.enableSlider === "true" &&
            typeof mainMedia.init === "function"
          ) {
            mainMedia.classList.remove("flickity-disabled");
            mainMedia.numberSlides = mainMedia.childElementCount;
            mainMedia.init();
          }

          if (
            thumbMedia &&
            thumbNodes.length > 1 &&
            thumbMedia.dataset.enableSlider === "true" &&
            typeof thumbMedia.init === "function"
          ) {
            thumbMedia.numberSlides = thumbMedia.childElementCount;
            thumbMedia.init();
          }
        }

        this.applyMediaUiState(mainMedia, thumbMedia, mediaNodes.length);

        requestAnimationFrame(() => {
          if (typeof mainMedia.update === "function") mainMedia.update();
          if (thumbMedia && typeof thumbMedia.update === "function") {
            thumbMedia.update();
          }
          const mainFlickity = window.FoxTheme.Flickity.data(mainMedia);
          if (mainFlickity) {
            mainFlickity.reloadCells();
            mainFlickity.reposition();
          }
          if (thumbMedia) {
            const thumbFlickity = window.FoxTheme.Flickity.data(thumbMedia);
            if (thumbFlickity) {
              thumbFlickity.reloadCells();
              thumbFlickity.reposition();
            }
          }
        });

        if (this.productMedia.domNodes) {
          this.productMedia.domNodes.medias = Array.from(
            this.productMedia.querySelectorAll(".f-product__media")
          );
          this.productMedia.domNodes.thumbnailItems = Array.from(
            this.productMedia.querySelectorAll(".f-product__media-thumbnails-item")
          );
        }

        if (this.productMedia.enableZoom) {
          this.productMedia.lightbox && this.productMedia.lightbox.destroy();
          this.productMedia.initImageZoom();
        }

        this.productMedia.removeAttribute("data-media-loading");
      }

      setupMetafieldVideoPlayback() {
        if (!this.productMedia) return;
        
        if (this.metafieldVideoObserver) {
          this.metafieldVideoObserver.disconnect();
        }
      
        const videos = this.productMedia.querySelectorAll("[data-metafield-video]");
        if (!videos.length) return;
      
        this.metafieldVideoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && entry.intersectionRatio > 0.5) {
                const playPromise = video.play();
                if (playPromise && typeof playPromise.catch === "function") {
                  playPromise.catch(() => {});
                }
              } else {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.5, 1] }
        );
      
        videos.forEach((v) => this.metafieldVideoObserver.observe(v));
      }

      setupMetafieldThumbPosters() {
        if (!this.productMedia) return;
      
        const thumbVideos = this.productMedia.querySelectorAll(
          "[data-metafield-thumb-video]"
        );
      
        thumbVideos.forEach((video) => {
          if (video.dataset.posterReady === "true") return;
      
          const seekToFrame = () => {
            try {
              if (video.readyState >= 1 && video.currentTime < 0.1) {
                video.currentTime = 0.1;
              }
            } catch (e) {}
          };
      
          video.addEventListener("loadedmetadata", seekToFrame, { once: true });
          video.addEventListener(
            "seeked",
            () => {
              video.dataset.posterReady = "true";
            },
            { once: true }
          );
      
          if (video.readyState >= 1) seekToFrame();
        });
      }

      updateMediaFromMetafieldUrls(variant) {
        if (!variant || !variant.id || !this.productMedia) return false;
        if (!this.hasAnyVariantMetafieldImages()) return false;

        const urls = this.getVariantMetafieldUrls(variant.id);
        if (urls.length > 0) {
          this.cacheDefaultGalleryNodes();
          const mediaNodes = urls.map((url, index) =>
            this.createMetafieldMediaNode(url, index, variant)
          );
          const thumbNodes = urls.map((url, index) =>
            this.createMetafieldThumbNode(url, index, variant)
          );
          this.replaceMediaNodes(mediaNodes, thumbNodes);
          this.setupMetafieldVideoPlayback();
          this.setupMetafieldThumbPosters();
          this.customVariantMediaActive = true;
          return true;
        }

        if (this.customVariantMediaActive && this.defaultMediaNodes) {
          const mediaNodes = this.defaultMediaNodes.map((node) =>
            node.cloneNode(true)
          );
          const thumbNodes = (this.defaultThumbNodes || []).map((node) =>
            node.cloneNode(true)
          );
          this.replaceMediaNodes(mediaNodes, thumbNodes);
          this.setupMetafieldVideoPlayback();
          this.customVariantMediaActive = false;
          return false;
        }

        return false;
      }

      // End of metafield images handling


      updateMedia(variant) {
        if (!this.productMedia) return;

        // If the variant has metafield images, they will take precedence over any other media handling logic
        const handledByMetafieldUrls = this.updateMediaFromMetafieldUrls(variant);
        if (handledByMetafieldUrls) return;
        // End of metafield images handling

        if (this.variantGroupImages && this.variantGroupImages.enable) {
          const isCarousel = this.productMedia.querySelector(".flickity-slider")
            ? true
            : false;
          const initalMediaIds = this.productMedia?.domNodes?.medias.map(
            (item) => item.dataset.mediaId
          );
          const groupImages = this.variantGroupImages.mapping.find(
            (item) => Number(item.id) === variant.id
          );
          const currentVariantMedia = groupImages
            ? groupImages.media
            : this.allMediaIds;

          if (!this.areArraysEquivalent(currentVariantMedia, initalMediaIds)) {
            const mainMedia = this.productMedia.querySelector(
              ".f-product__media-list"
            );
            const thumbMedia = this.productMedia.querySelector(
              ".f-product__media-thumbnails"
            );
            if (isCarousel) {
              const mainFlickity = window.FoxTheme.Flickity.data(mainMedia);

              let mediaToRemove =
                mainMedia.querySelectorAll(".f-product__media");
              mediaToRemove &&
                mediaToRemove.forEach(function (slide) {
                  mainFlickity.remove(slide);
                });
              let mediaToShow = this.filteredMediaForSelectedVariant(
                this.productMedia.domNodes.medias,
                currentVariantMedia
              );

              mediaToShow.forEach(function (slide, index) {
                const zoomButton = slide.querySelector(".js-photoswipe--zoom");
                if (zoomButton) {
                  zoomButton.setAttribute("data-media-index", index);
                }
                slide.setAttribute("data-media-index", index);
                slide.setAttribute("data-index", index);
                mainFlickity.append(slide);
              });

              if (thumbMedia && this.productMedia.domNodes.thumbnailItems) {
                const thumbnailsFlickity =
                  window.FoxTheme.Flickity.data(thumbMedia);

                let thumbsToRemove = thumbMedia.querySelectorAll(
                  ".f-product__media-thumbnails-item"
                );
                thumbsToRemove &&
                  thumbsToRemove.forEach(function (slide) {
                    thumbnailsFlickity.remove(slide);
                  });

                let thumbsToShow = this.filteredMediaForSelectedVariant(
                  this.productMedia.domNodes.thumbnailItems,
                  currentVariantMedia
                );
                thumbsToShow.forEach(function (slide, index) {
                  slide.setAttribute("data-thumbnail-index", index);
                  slide.setAttribute("data-index", index);
                  thumbnailsFlickity.append(slide);
                });

                thumbMedia.classList.remove(
                  "disable-transition",
                  "md:disable-transition"
                );
                if (thumbsToShow.length < 5) {
                  thumbMedia.classList.add("disable-transition");
                }
                if (thumbsToShow.length < 6) {
                  thumbMedia.classList.add("md:disable-transition");
                }
                thumbnailsFlickity.option({
                  wrapAround: thumbsToShow.length > 5,
                });
                thumbnailsFlickity.reloadCells();
                thumbnailsFlickity.reposition();
              }

              mainFlickity.select(0, false, false);
            } else {
              let mediaToShow = this.filteredMediaForSelectedVariant(
                this.productMedia.domNodes.medias,
                currentVariantMedia
              );
              mainMedia.innerHTML = "";
              mediaToShow.forEach((item, index) => {
                const zoomButton = item.querySelector(".js-photoswipe--zoom");
                if (zoomButton) {
                  zoomButton.setAttribute("data-media-index", index);
                }
                item.setAttribute("data-media-index", index);
                item.setAttribute("data-index", index);
                mainMedia.append(item);
              });
            }

            // Re-init Photoswipe
            if (this.productMedia && this.productMedia.enableZoom) {
              this.productMedia.lightbox &&
                this.productMedia.lightbox.destroy();
              this.productMedia.initImageZoom();
            }
          }

          this.productMedia.removeAttribute("data-media-loading");
        } else {
          if (!variant.featured_media) return;
          if (typeof this.productMedia.setActiveMedia === "function") {
            this.productMedia.setActiveMedia(variant.featured_media.id);
          }
        }
      }

      setUnavailable() {
        this.updateButton(true, window.FoxThemeStrings.unavailable);

        const selectors = [
          "Price",
          "Inventory",
          "Sku",
          "PricePerItem",
          "VolumeNote",
          "Volume",
          "QuantityRules",
          "QuantityRulesCart",
        ]
          .map((id) => `#${id}-${this.sectionId}`)
          .join(", ");
        document
          .querySelectorAll(selectors)
          .forEach((selector) => selector.setAttribute("hidden", ""));
      }

      areArraysEquivalent(firstArray, secondArray) {
        if (!Array.isArray(firstArray) || !Array.isArray(secondArray)) {
          return false;
        }

        if (firstArray.length !== secondArray.length) {
          return false;
        }

        const sortedFirstArray = [...firstArray].sort();
        const sortedSecondArray = [...secondArray].sort();

        return sortedFirstArray.every(
          (value, index) => value === sortedSecondArray[index]
        );
      }

      filteredMediaForSelectedVariant(items, currentVariantMedia) {
        let index = 0;
        let prioritizedResults = [];
        let otherResults = [];
        items.forEach((item) => {
          const dataIdMedia = item.dataset.mediaId;
          if (currentVariantMedia && currentVariantMedia.length > 0) {
            if (currentVariantMedia.includes(dataIdMedia)) {
              item.dataset.index = index++;
              prioritizedResults.push(item);
            }

            if (item.dataset.mediaType !== "image") {
              item.dataset.index = index++;
              otherResults.push(item);
            }
          } else {
            item.dataset.index = index++;
            prioritizedResults.push(item);
          }
        });

        const sortByVariantOrder = (a, b) => {
          const indexA = currentVariantMedia.indexOf(a.dataset.mediaId);
          const indexB = currentVariantMedia.indexOf(b.dataset.mediaId);
          return indexA - indexB;
        };

        prioritizedResults.sort(sortByVariantOrder);

        const results = [...prioritizedResults, ...otherResults];

        return results;
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute("data-original-section-id")) {
          this.cartUpdateUnsubscriber = FoxThemeEvents.subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        fetch(
          `${this.getAttribute(
            "data-product-url"
          )}?variant=${currentVariantId}&section_id=${this.sectionId}`
        )
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.updateQuantityRules(
              this.sectionId,
              this.productId,
              parsedHTML
            );
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxThemeEvents.emit(PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }
    }
  );
}
